import { HTMLProps } from 'react';
import { useDarkMode } from '@glu/theming';
import classnames from 'classnames';
import useStyles from './HelpText.styles';

const HelpText = ({ children }: Pick<HTMLProps<HTMLParagraphElement>, 'children'>) => {
  const dark = useDarkMode();
  const classes = useStyles();
  return <p className={classnames(classes.root, { [classes.dark]: dark })}>{children}</p>;
};

export default HelpText;
